// extracted by mini-css-extract-plugin
module.exports = {"height-bar-mobile":"55px"};